import { DateTime } from 'luxon';

export const isLicenseAboutToExpire = (expireDate: string): boolean =>
  DateTime.local().plus({ days: 30 }) > DateTime.fromISO(expireDate);
export const getDaysBeforeExpire = (expireDate: string): number => {
  const { days } = DateTime.fromISO(expireDate).diffNow(['days']);
  return Math.ceil(days);
};
